<script lang="ts">
	import { Button, IconButton } from '@Shelly/shelly-design-system';
	import { user_settings } from 'src/stores/account/user';
	import { postReq } from 'src/services/http';

	$: userTempUnit = $user_settings?.units?.temp_unit;

	const buttons = [
		{ text: 'Reset', value: '' },
		{ text: 'C°', value: 'C' },
		{ text: 'F°', value: 'F' },
	];

	async function saveTempUnit(unit) {
		const res = await postReq('/user/set_account_units', {
			set: 'temp_unit',
			val: unit,
		});

		if (res.isok) {
			user_settings.set({
				...$user_settings,
				units: { ...$user_settings.units, temp_unit: unit },
			});
		}
	}
</script>

{#each buttons as button}
	<Button
		class="mr-s"
		size="m"
		variant={userTempUnit === button.value ? 'primary' : 'secondary'}
		on:click={() => {
			saveTempUnit(button.value);
		}}>{button.text}</Button
	>
{/each}
